<template>
  <div class="backimg">
    <div class="search-content" style="width:100%;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="200"><strong>待确认</strong><span class="badge" v-if="statusnumber200>0">{{statusnumber200}}</span>
        </el-menu-item>
        <el-menu-item index="650">退货待确认<span class="badge" v-if="statusnumber650>0">{{statusnumber650}}</span>
        </el-menu-item>
        <el-menu-item index="350">待发货<span class="badge" v-if="statusnumber350>0">{{statusnumber350}}</span></el-menu-item>
        <el-menu-item index="500">已发货</el-menu-item>
        <!--<el-menu-item index="all">全部订单</el-menu-item>-->
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <comment :is="currentcomponent" :canMultySelect="canMultySelect" :roletype="roletype" :mystatus="status" :invoiceshow="false"
               v-if="visible" @bindTip="bindTip"></comment>
    </el-main>
  </div>

</template>

<script>
  import CstagreementList from './CstagreementList';
  import {countlist} from '@/api/set/csagreement';
  import {simulationLogin, checkModuleRight, getModuleRight} from '@/api/login'

  export default {
    data() {
      return {
        activeIndex: '200',
        currentcomponent: 'CstagreementList',
        visible: true,
        canMultySelect:true,
        status: '200',
        roletype:'order',
        statuseslist: "200;650;350",
        statusnumber200: 0,
        statusnumber650: 0,
        statusnumber350:0,
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.status = key
        this.roletype=(key==650)?"customerservice":((key==350)?"store":"order");
        this.visible = false
        this.currentcomponent = 'CstagreementList';
        this.$nextTick(() => {
          this.visible = true
        })
      },
      bindTip() {
        this.statusnumber200 = 0
        this.statusnumber650 = 0
        this.statusnumber350 = 0;
        countlist({statuseslist: this.statuseslist, roletype: 'order'}).then(response => {
          response.data.obj.forEach(item => {
            if (item.status == 200) {
              this.statusnumber200 = item.number
            } else if (item.status == 650) {
              this.statusnumber650 = item.number
            } else if (item.status == 350) {
              this.statusnumber350 = item.number
            }
          })
        })
      }
    },
    mounted() {
      this.bindTip();
    },
    components: {
      CstagreementList
    }

  }


</script>

<style scoped>
  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width: 100%;
    margin: 0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Order4Supply.vue